"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/**
 * @param theme object
 */

/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/

/**
Remove the inheritance of text transform in Edge and Firefox.
1. Remove the inheritance of text transform in Firefox.
*/
var preflight = process.env.NODE_ENV === "production" ? {
  name: "1rucah3",
  styles: "font-family:inherit;font-size:100%;margin:0;text-transform:none;background:transparent;border:0;padding:0;line-height:inherit;transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);cursor:pointer;&:focus{outline:none;}"
} : {
  name: "190zrha-preflight",
  styles: "font-family:inherit;font-size:100%;margin:0;text-transform:none;background:transparent;border:0;padding:0;line-height:inherit;transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);cursor:pointer;&:focus{outline:none;};label:preflight;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var disabled = process.env.NODE_ENV === "production" ? {
  name: "o5a1fi",
  styles: "&[disabled]{cursor:default;pointer-events:none;}"
} : {
  name: "b8kl08-disabled",
  styles: "&[disabled]{cursor:default;pointer-events:none;};label:disabled;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)(preflight, ";padding:0.5rem ", theme.spacing.base, ";border-radius:", theme.spacing['3'], ";text-align:center;border-width:", theme.spacing['1'], ";border-style:solid;white-space:nowrap;letter-spacing:0;", disabled, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};
/**
 * @param  theme Primary Button Style
 */


var primary = function primary(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.buttonPrimary.background, ";border-color:", theme.color.buttonPrimary.border, ";color:", theme.color.buttonPrimary.text, ";&[disabled]{background-color:", theme.color.buttonPrimary.backgroundDisabled, ";border-color:", theme.color.buttonPrimary.borderDisabled, ";color:", theme.color.buttonPrimary.textDisabled, ";}&:hover{background-color:", theme.color.buttonPrimary.backgroundHover, ";border-color:", theme.color.buttonPrimary.borderHover, ";color:", theme.color.buttonPrimary.textHover, ";}&:active{background-color:", theme.color.buttonPrimary.backgroundPressed, ";border-color:", theme.color.buttonPrimary.borderPressedisabled, ";color:", theme.color.buttonPrimary.textPressed, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:primary;"));
};
/**
 * @param  {} theme Secondary Button Style
 */


var secondary = function secondary(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.buttonSecondary.background, ";border-color:", theme.color.buttonSecondary.border, ";color:", theme.color.buttonSecondary.text, ";&[disabled]{background-color:", theme.color.buttonSecondary.backgroundDisabled, ";border-color:", theme.color.buttonSecondary.borderDisabled, ";color:", theme.color.buttonSecondary.textDisabled, ";}&:hover{background-color:", theme.color.buttonSecondary.backgroundHover, ";border-color:", theme.color.buttonSecondary.borderHover, ";color:", theme.color.buttonSecondary.textHover, ";}&:active{background-color:", theme.color.buttonSecondary.backgroundPressed, ";border-color:", theme.color.buttonSecondary.borderPressed, ";color:", theme.color.buttonSecondary.textPressed, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:secondary;"));
};
/**
 * @param  {} theme Tertiary Button Style
 */


var tertiary = function tertiary(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.buttonTertiary.background, ";border-color:", theme.color.buttonTertiary.border, ";color:", theme.color.buttonTertiary.text, ";&[disabled]{background-color:", theme.color.buttonTertiary.backgroundDisabled, ";border-color:", theme.color.buttonTertiary.borderDisabled, ";color:", theme.color.buttonTertiary.textDisabled, ";}&:hover{background-color:", theme.color.buttonTertiary.backgroundHover, ";border-color:", theme.color.buttonTertiary.borderHover, ";color:", theme.color.buttonTertiary.textHover, ";}&:active{background-color:", theme.color.buttonTertiary.backgroundPressed, ";border-color:", theme.color.buttonTertiary.borderPressed, ";color:", theme.color.buttonTertiary.textPressed, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:tertiary;"));
};
/**
 * @param  {} theme Warning Button Style
 */


var warning = function warning(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.buttonWarning.background, ";border-color:", theme.color.buttonWarning.border, ";color:", theme.color.buttonWarning.text, ";&[disabled]{background-color:", theme.color.buttonWarning.backgroundDisabled, ";border-color:", theme.color.buttonWarning.borderDisabled, ";color:", theme.color.buttonWarning.textDisabled, ";}&:hover{background-color:", theme.color.buttonWarning.backgroundHover, ";border-color:", theme.color.buttonWarning.borderHover, ";color:", theme.color.buttonWarning.textHover, ";}&:active{background-color:", theme.color.buttonWarning.backgroundPressed, ";border-color:", theme.color.buttonWarning.borderPressed, ";color:", theme.color.buttonWarning.textPressed, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:warning;"));
};

var warningOutline = function warningOutline(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.buttonWarningOutline.background, ";border-color:", theme.color.buttonWarningOutline.border, ";color:", theme.color.buttonWarningOutline.text, ";&[disabled]{background-color:", theme.color.buttonWarningOutline.backgroundDisabled, ";border-color:", theme.color.buttonWarningOutline.borderDisabled, ";color:", theme.color.buttonWarningOutline.textDisabled, ";}&:hover{background-color:", theme.color.buttonWarningOutline.backgroundHover, ";border-color:", theme.color.buttonWarningOutline.borderHover, ";color:", theme.color.buttonWarningOutline.textHover, ";}&:active{background-color:", theme.color.buttonWarningOutline.backgroundPressed, ";border-color:", theme.color.buttonWarningOutline.borderPressed, ";color:", theme.color.buttonWarningOutline.textPressed, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:warningOutline;"));
};
/**
 * @param  {} theme Note Button Style
 */


var note = function note(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.buttonNote.background, ";border-color:", theme.color.buttonNote.border, ";color:", theme.color.buttonNote.text, ";&[disabled]{background-color:", theme.color.buttonNote.backgroundDisabled, ";border-color:", theme.color.buttonNote.borderDisabled, ";color:", theme.color.buttonNote.textDisabled, ";}&:hover{background-color:", theme.color.buttonNote.backgroundHover, ";border-color:", theme.color.buttonNote.borderHover, ";color:", theme.color.buttonNote.textHover, ";}&:active{background-color:", theme.color.buttonNote.backgroundPressed, ";border-color:", theme.color.buttonNote.borderPressed, ";color:", theme.color.buttonNote.textPressed, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:note;"));
};
/* Link Button Style */


var linkBase = /*#__PURE__*/(0, _react.css)(preflight, ";", disabled, ";transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);" + (process.env.NODE_ENV === "production" ? "" : ";label:linkBase;"));

var link = function link(theme) {
  return /*#__PURE__*/(0, _react.css)(linkBase, ";color:", theme.color.brand['800'], ";text-decoration:none;&[disabled]{color:", theme.color.buttonSecondary.textDisabled, ";}&:hover{color:", theme.color.brand['900'], ";}&:active{color:", theme.color.brand['800'], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:link;"));
};

var secondaryLink = function secondaryLink(theme) {
  return /*#__PURE__*/(0, _react.css)(linkBase, ";color:", theme.color.buttonPrimary.text, ";text-decoration:underline;font-weight:", theme.fontWeight.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:secondaryLink;"));
};

var tertiaryLink = function tertiaryLink(theme) {
  return /*#__PURE__*/(0, _react.css)(linkBase, ";text-decoration:underline;color:", theme.color.linkTertiary.text, ";font-weight:", theme.fontWeight.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:tertiaryLink;"));
};
/* SIZES */


var small = function small(theme) {
  return /*#__PURE__*/(0, _react.css)("padding:", (0, _util.rem)(5), " ", theme.spacing['10'], ";font-size:", theme.fontSize.base, ";line-height:", (0, _util.rem)(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var big = function big(theme) {
  return /*#__PURE__*/(0, _react.css)("padding:", (0, _util.rem)(7), " ", theme.spacing['10'], ";font-size:", theme.fontSize.x2large, ";line-height:", theme.lineHeight.leadingNormal, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:big;"));
};

var styles = {
  preflight: preflight,
  primary: primary,
  secondary: secondary,
  tertiary: tertiary,
  warning: warning,
  warningOutline: warningOutline,
  note: note,
  link: link,
  secondaryLink: secondaryLink,
  tertiaryLink: tertiaryLink
};
exports.styles = styles;
var sizes = {
  small: small,
  big: big
};
exports.sizes = sizes;
//# sourceMappingURL=button.styles.js.map